import React, { useState, useEffect, useContext } from 'react';
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import { Link } from 'react-router-dom';
import avtar from "../../../assets/images/avtar.png";
import greencheckicon from "../../../assets/images/greencheckicon.svg";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import './Reviewtab.css'
import EmployeeSurveyTable from '../components/EmployeeSurveyTable/EmployeeSurveyTable';
import { useAuth } from '../../firebase/AuthProvider';
import { getUserPerformance, PerformanceData } from '../../services/performanceServices/PerformanceService';
import Loader from '../components/loader/Loader';

const Reviewtab = () => {
    const { currentUser, currentUserInfo } = useAuth();

    interface MetricCardProps {
        title: string;
        value: number;
        rating: string;
    }

    interface Metric {
        title: string;
        value: number;
        rating: string;
    }

    const MetricCard: React.FC<MetricCardProps> = ({ title, value, rating }) => {
        const color =
            value >= 80 ? "text-[#008236]" : value >= 50 ? "text-[#EBBC00]" : "text-[#FF0000]";

        return (
            <div className="w-full border rounded-xl p-4 bg-white">
                <p className="text-[#101828] font-poppins text-[16px] leading-[20px]">
                    {title}
                </p>

                <p className={`font-poppins text-[24px] leading-[24px] mt-2 ${color}`}>
                    {value}%
                    <span className="ml-2 text-[#6A7282] text-[14px] leading-[16px] font-normal">
                        {rating}
                    </span>
                </p>
            </div>
        );
    };

    const [performanceData, setPerformanceData] = useState<PerformanceData | null>(null);
    const [year, setYear] = useState<number>(2025);

    useEffect(() => {
        const fetchPerformanceData = async () => {
            if (currentUser && currentUserInfo) {
                try {
                    const token = await currentUser.getIdToken();
                    const data = await getUserPerformance(currentUserInfo.id, token);
                    setPerformanceData(data);
                } catch (err) {
                    console.error('Error fetching performance data:', err);
                }
            }
        };

        fetchPerformanceData();
    }, [currentUser, currentUserInfo]);

    if (!performanceData) {
        return <Loader />;
    }

    const metricsPerformance: Metric[] = [
        { title: 'Timeliness', value: performanceData.timeliness, rating: performanceData.timelinessRating },
        { title: 'Responsiveness', value: performanceData.responsiveness, rating: performanceData.responsivenessRating },
        { title: 'Activity Tracking', value: performanceData.activityTracking, rating: performanceData.activityTrackingRating },
        { title: 'Caseload', value: performanceData.caseload, rating: performanceData.caseloadRating },
        { title: 'Person-Centered', value: performanceData.personCentered, rating: performanceData.personCenteredRating },
        { title: 'Admin Requests', value: performanceData.adminRequests, rating: performanceData.adminRequestsRating },
    ];


    return (
        <>
            <div className="w-full">
                {/* Header */}
                <div className="flex justify-between items-center">
                    <h2 className="text-[#101828] font-poppins text-2xl font-normal m-0">Performance</h2>
                    <div>
                        <select
                            className="border rounded-lg px-4 py-2 text-[#101828] w-[100px]"
                            value={year}
                            onChange={(e) => setYear(Number(e.target.value))}
                        >
                            <option value={2025} className=''>2025</option>
                            {/* Add more years dynamically as needed */}
                        </select>
                    </div>
                </div>

                {/* Subtitle */}
                <p className="text-[#6A7282] font-poppins text-[16px] leading-[20px] mb-6">
                    Overall performance across all metrics
                </p>

                {/* Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 mb-10">
                    {metricsPerformance.map((m) => (
                        <MetricCard key={m.title} title={m.title} value={m.value} rating={m.rating} />
                    ))}
                </div>
            </div>
            {/* <div>
                <EmployeeSurveyTable />
            </div> */}

        </>
    );
};

export default Reviewtab;